import React from 'react';
import InlineEditBase from './InlineEditBase';
import Input from '../Input';

interface InlineEditTextProps {
  value: string | number | undefined;
  onSave: (value: string | number) => Promise<void> | void;
  onCancel?: () => void;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  type?: 'text' | 'number';
  required?: boolean;
  label?: string;
  showEditButton?: boolean;
}

const InlineEditText: React.FC<InlineEditTextProps> = ({
  value,
  onSave,
  onCancel,
  disabled = false,
  className = '',
  placeholder,
  type = 'text',
  required = false,
  label,
  showEditButton = true,
}) => {
  return (
    <InlineEditBase
      value={value}
      onSave={onSave}
      onCancel={onCancel}
      disabled={disabled}
      className={className}
      showEditButton={showEditButton}
    >
      {({ isEditing, value: editValue, onChange, onSave, onCancel, inputRef }) => {
        if (!isEditing) {
          return (
            <div className="inline-flex items-center">
              <span className="font-medium">{value || <span className="text-[var(--color-neutral-400)] italic">Not set</span>}</span>
            </div>
          );
        }

        return (
          <div className="animate-slide-down">
            {label && <label className="block text-sm font-medium text-[var(--color-default-font)] mb-1">{label}</label>}
            <Input
              ref={inputRef as React.RefObject<HTMLInputElement>}
              type={type}
              value={editValue.toString()}
              onChange={(e) => onChange(type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  onSave();
                } else if (e.key === 'Escape') {
                  e.preventDefault();
                  onCancel();
                }
              }}
              placeholder={placeholder}
              required={required}
              className="w-full"
            />
          </div>
        );
      }}
    </InlineEditBase>
  );
};

export default InlineEditText;

